'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = HotelInfoPanel;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _emailStyleTools = require('helpers/emailStyleTools');

var _basketHelpers = require('helpers/basketHelpers');

var _HotelNameAndAddress = require('./HotelNameAndAddress');

var _HotelNameAndAddress2 = _interopRequireDefault(_HotelNameAndAddress);

var _CheckInAndCheckOut = require('./CheckInAndCheckOut');

var _CheckInAndCheckOut2 = _interopRequireDefault(_CheckInAndCheckOut);

var _dateTimeHelper = require('helpers/dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function HotelInfoPanel(props) {
  var components = props.components,
      option = props.option,
      t = props.t;

  var styleHotelContainer = (0, _emailStyleTools.containerStyles)(components, 'HotelContainer');

  return _react2.default.createElement(
    'table',
    { style: _emailStyleTools.fullMinimal, 'data-component': 'HotelInfoPanel' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleHotelContainer, _emailStyleTools.padTen) },
          _react2.default.createElement(
            'table',
            { style: _emailStyleTools.fullMinimal, 'data-component': 'HotelInfoPanel__Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '10px', paddingBottom: '0', paddingLeft: '0', verticalAlign: 'top', width: '20%' } },
                  _react2.default.createElement(
                    'table',
                    { style: _emailStyleTools.fullMinimal },
                    _react2.default.createElement(
                      'tbody',
                      null,
                      _react2.default.createElement(
                        'tr',
                        null,
                        _react2.default.createElement(
                          'td',
                          { style: (0, _extends3.default)({ textAlign: 'center' }, _emailStyleTools.noPad) },
                          _react2.default.createElement('img', { src: 'https://goprivate.wspan.com/Scripts/us/GNG/ImagesGNG/hotel.png', alt: 'logo', style: { width: '50px', height: '50px' } })
                        )
                      )
                    )
                  )
                ),
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '5px', paddingBottom: '0', paddingLeft: '0', verticalAlign: 'top', width: '40%' } },
                  _react2.default.createElement(_HotelNameAndAddress2.default, {
                    name: (0, _basketHelpers.getHotelName)(option),
                    address: (0, _basketHelpers.getHotelAddress)(option),
                    components: components
                  })
                ),
                _react2.default.createElement(
                  'td',
                  { style: { paddingTop: '0', paddingRight: '0', paddingBottom: '0', paddingLeft: '5px', verticalAlign: 'top', width: '40%' } },
                  _react2.default.createElement(_CheckInAndCheckOut2.default, {
                    checkIn: _dateTimeHelper2.default.getDate(option.hotelRoom.hotelProperty.checkInDate),
                    checkOut: _dateTimeHelper2.default.getDate(option.hotelRoom.hotelProperty.checkOutDate),
                    components: components,
                    t: t
                  })
                )
              )
            )
          )
        )
      )
    )
  );
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Hotel/Email/Active/HotelInfoPanel.jsx
// module id = 1522
// module chunks = 0